import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { CompanyPageClickRequestModel } from '../models'

export class PostCompanyHomepageClicksApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'general/homepageCompanyTrackClick',
      requesterInfo,
    })
  }

  public async postCompanyHomepageClicks(request: CompanyPageClickRequestModel): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
